import { SITE } from "../../lib/site-data";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0E0C09] text-[#F8F4ED]/70 py-10"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img
            src={SITE.logoUrl}
            alt="Long Horn Trailer Rentals"
            className="w-9 h-9 rounded-full ring-1 ring-[#D4A24C]/40"
          />
          <div className="text-sm">
            <div className="font-display font-semibold text-[#F8F4ED]">
              {SITE.name}
            </div>
            <div className="text-xs">Burlington, NC · 24/7</div>
          </div>
        </div>
        <div className="text-xs text-center sm:text-right">
          © {new Date().getFullYear()} {SITE.name}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};
